import React from "react";
import {useHistory, useRouteMatch} from "react-router-dom";
import {Api} from "../app-controller.js";
import {useAuth} from "../components/content/auth.jsx";
import Swal from "sweetalert2";

import Leaflet from "leaflet";
import {MapContainer, TileLayer, Marker, Popup} from "react-leaflet";
import "leaflet/dist/leaflet.css";

Leaflet.Icon.Default.imagePath = "../node_modules/leaflet";

delete Leaflet.Icon.Default.prototype._getIconUrl;

Leaflet
    .Icon
    .Default
    .mergeOptions(
        {iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"), iconUrl: require("leaflet/dist/images/marker-icon.png"), shadowUrl: require("leaflet/dist/images/marker-shadow.png")}
    );

class EstablishmentEdition extends React.Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this
            .handleSubmit
            .bind(this);
        this.handleStep = this
            .handleStep
            .bind(this);
        this.handleDepartamentos = this
            .handleDepartamentos
            .bind(this);
        this.handleMunicipios = this
            .handleMunicipios
            .bind(this);
        this.handlePais = this
            .handlePais
            .bind(this);
        this.handleActividades = this
            .handleActividades
            .bind(this);
        this.handleCondiciones = this
            .handleCondiciones
            .bind(this);
        this.handleRepresentante = this
            .handleRepresentante
            .bind(this);
        this.addRep = this
            .addRep
            .bind(this);
        this.removeRep = this
            .removeRep
            .bind(this);

        this.handleRegente = this
            .handleRegente
            .bind(this);
        this.handleGuidRegente = this
            .handleGuidRegente
            .bind(this);
        this.handleExisteRegente = this
            .handleExisteRegente
            .bind(this);
        this.removeReg = this
            .removeReg
            .bind(this);

        this.handleEstablecimiento = this
            .handleEstablecimiento
            .bind(this);
        this.handleGuidEstablecimiento = this
            .handleGuidEstablecimiento
            .bind(this);
        this.handleExisteEstablecimiento = this
            .handleExisteEstablecimiento
            .bind(this);
        this.removeEst = this
            .removeEst
            .bind(this);

        this.handleWarning = this
            .handleWarning
            .bind(this);
        this.handleLatLong = this
            .handleLatLong
            .bind(this);
        this.handleDireccion = this
            .handleDireccion
            .bind(this);
        this.maxLengthCheck = this
            .maxLengthCheck
            .bind(this);
        this.handleSave = this
            .handleSave
            .bind(this);
            this.handleRegresar = this
            .handleRegresar
            .bind(this);

        this.validaForma = this
            .validaForma.bind(this);

          this.handleAceptaCambios=this.handleAceptaCambios.bind(this);

        this.state = {
            id: this
                .props
                .match
                .params["id"],
            solid: this
                .props
                .match
                .params["solid"],
            nacional: "",
            tipo_establecimiento_id: "",
            actividad_id: null,
            actividades: [],
            pais: "",
            activeStep: "establecimiento",
            wizzard: [
                {
                    titulo: "Establecimiento",
                    descripcion: "Datos del establecimiento",
                    estado: "active "
                }, {
                    titulo: "Representante Legal",
                    descripcion: "Datos del representante legal",
                    estado: "disabled"
                }, {
                    titulo: "Regente",
                    descripcion: "Información del regente",
                    estado: "disabled"
                }, {
                    titulo: "Establecimientos relacionados",
                    descripcion: "Establecimientos relacionados con el actual",
                    estado: "disabled"
                }, {
                    titulo: "Características",
                    descripcion: "Características del establecimiento",
                    estado: "disabled"
                }
            ],
            options_identification: {
                tipo_identificacion: Api.loadCatalogue("cat_tipo_documento")
            },
            options_conditions: {
                condiciones: Api.loadCatalogue("cat_condicion")
            },
            options_locations: Api.loadCatalogue("locations"),
            option_paises: Api.loadCatalogue("countries"),
            telefono: "",
            lada: "+",
            correo_electronico: "",
            departamento_id: "",
            departamento_name: "",
            municipio_id: "",
            municipio_name: "",
            razon_social: "",
            area: "",
            direccion: "",
            direccion_bodegas: "",
            condiciones: [],
            procesando: false,
            locked: "blockea",
            numero_de_identificacion: "",
            disabledR: false,
            //existe_regente: false, verifica que se lleno y valido la parte de regente
            latitud: "12.13282",
            longitud: "-86.2504",
            representante_legal: {
                nombres: "",
                apellido_paterno: "",
                apellido_materno: "",
                direccion: "",
                tipo_documento_id: "", //tipo identificacion
                numero_identificacion: "",
                telefono: "",
                email: "",
                departamento_id: "",
                municipio_id: ""
            },
            regente: {
                regente_id: "",
                nombres: "",
                apellido_paterno: "",
                apellido_materno: "",
                guid: ""
            },
            establecimiento: {
                establecimiento_id: "",
                razon_social: "",
                guid: ""
            },
            regentes: [],
            representantes: [],
            establecimientos: [],
            latLongDir: ""
        };

    }

    componentDidMount() {




        let identificacion = Api.loadCatalogue("cat_tipo_documento");
        let ids = [];
        for (let id in identificacion) {
            if (identificacion[id].id === "1" || identificacion[id].id === "2") {
                ids.push(identificacion[id]);
            }
        }
        this.setState({
            options_identification: {
                tipo_identificacion: ids
            }
        });

        Api.loading(1);
        Api
            .fetch(
                "app/getEstablecimiento?id=" + this.props.match.params["id"] + "&solid=" +
                this.props.match.params["solid"]
            )
            .then(r => {


                let e = r;
                document.getElementById("anotacion_marginal").classList = "col-12 hide";
                    if (e.nota_marginal) {
                        this.setState({
                        am: "NM",
                        nota_marginal: e.nota_marginal,
                        solicitud_est: e.nota_marginal.solicitud,
                        });

                        document.getElementById("anotacion_marginal").classList = "col-12";
                        document.getElementById("nota_marginal").innerText =
                        e.nota_marginal.descripcion;
                        import(`../components/notas-marginales/NMGeneral.jsx`).then((m) => {
                        m.detail(e.nota_marginal, (r) => {
                            let notaForm = Api.form(r);
                            notaForm.querySelector("#peticion").innerText =
                            e.nota_marginal.peticion;
                        });
                        });
                    }
              let block="";
              let _r = r; //auxiliar
                if (r.id) {
                    this.setState({
                        "estatus_tramite_id": r.nota_marginal.estatus_tramite_id,
                        "locked": block,
                        "razon_social": r.razon_social,
                        "telefono": r.telefono,
                        "correo_electronico": r.correo_electronico,
                        "numero_de_identificacion": r.numero_de_identificacion,
                        "departamento_id": r.departamento_id,
                        "municipio_id": r.municipio_id,
                        "direccion": r.direccion,
                        "direccion_bodegas": r.direccion_bodegas,
                        "area": r.area
                    });

                    Api
                        .fetch(
                            "app/getRepresentanteEstablecimiento?id=" + this.props.match.params["id"] + "&?" +
                            "page=1&rowsPerPage=100"
                        )
                        .then(r => {

                            this.setState({representantes: r.data})
                        });

                    Api
                        .fetch(
                            "app/getRegenteEstablecimiento?id=" + this.props.match.params["id"] + "&?page=1" +
                            "&rowsPerPage=100"
                        )
                        .then(r => {

                            this.setState({regentes: r.data})
                        });

                    Api
                        .fetch(
                            "app/getCondicionesEstablecimiento?id=" + this.props.match.params["id"] + "&?pa" +
                            "ge=1&rowsPerPage=100"
                        )
                        .then(r => {
                            for (let c in r.data) {
                                let chk = document.querySelector("#con-" + r.data[c]["id"]);
                                chk.checked = true;
                            }
                        });

                    Api
                        .fetch(
                            "app/getEstablecimientosRelacionados?id=" + this.props.match.params["id"] + "&?" +
                            "page=1&rowsPerPage=100"
                        )
                        .then(r => {
                            this.setState({establecimientos: r})
                           
                            if(_r.nota_marginal.estatus_tramite_id==="14"){
                              Api.loading(1);
                              block="blockea";
                              let data = JSON.parse(JSON.stringify(this.state));
                              Api //Guardamos un snap de la informacion actual, en caso de respaldo
                                .fetch("app/saveEstablecimientoSnap", {
                                    data: data,
                                    bk:1
                                }, "POST")
                                .then((data) => {
                                   
                                      Api  //Nos traemos el snap que queremos aplicar
                                      .fetch(
                                          "app/getEstablecimientoSnap?id=" + this.props.match.params["id"] + "&solid=" +
                                          this.props.match.params["solid"]
                                      )
                                      .then(r => {
                                        if(r){

                                          r.estatus_tramite_id=14;
                                          r.locked=block;
                                          this.setState(r);
                                          
                                          let chks = document.querySelectorAll(".conchk");
                                          for(let chk in chks){
                                           
                                            if(typeof chks[chk]==="object"){
                                              let el = chks[chk];
                                              el.checked=false; 
                                            }
                                          }
                                        
                                          for (let c in r.condiciones) {
                                            let chk = document.querySelector("#con-" + r.condiciones[c]);
                                                chk.checked = true;
                                          }

                                         
                                        }
                                        Api.loading(0);
                                      });

                                });
                            }else{
                                Api.loading(0);
                            }
                           
                        });

                }

            });

        // this.setState({ nacional: data.nacional, tipo_establecimiento_id:
        // data.tipo_establecimiento_id });

        this.setState({"actualiza":"hide"});
        //console.log(this.props.match.params);
        let inter = {};
        Api.fetch("app/getNacionalEst?id=" + this.props.match.params["id"]).then(
            (data) => {
              if (data) {
                this.setState({
                  nacional: data.nacional,
                  tipo_establecimiento_id: data.tipo_establecimiento_id,
                  actividad_id: data.actividad_id || null,
                  actividades: data.actividad_id ? [String(data.actividad_id)] : [],
                });
              }
              inter = setInterval(this.validaForma,333);
              this.setState({inter:inter});

            }
          );
       

    }

    validaForma(){

        let chks = document.querySelectorAll(".conchk");
        
        if(!chks.length){
           clearInterval(this.state.inter);
           return;
        }

       let chck = campo=>{
           if(this.state[campo]!==""){
               return true;
           }else{
               return false;
           }
       }
       
      let campos = ["razon_social","telefono","correo_electronico","numero_de_identificacion",
                    "departamento_id","municipio_id","direccion","latitud","longitud"];

      let ok=0;
      for(let c in campos){
          if(chck(campos[c])){
              ok++;
          }
      }

      if(ok===campos.length){
        this.setState({"actualiza":""});
      }else{
        this.setState({"actualiza":"hide"});
        return;
      }
       
    
       

      if(this.state.representantes.length>0){
        this.setState({"actualiza":""});
      }else{
        this.setState({"actualiza":"hide"});
        return;
      }

      if(this.state.regentes.length>0){
        this.setState({"actualiza":""});
      }else{
        this.setState({"actualiza":"hide"});
        return;
      }


        //Si es nacional

        if(this.state.nacional==="1"){
        campos = ["area","direccion_bodegas"];

        ok=0;
        for(let c in campos){
        if(chck(campos[c])){
        ok++;
        }
        }

        if(ok===campos.length){
        this.setState({"actualiza":""});
        }else{
        this.setState({"actualiza":"hide"});
        return;
        }


        let cond = [];
        for(let chk in chks){
        if(typeof chks[chk]==="object"){
            let el = chks[chk];
            
            if(el.checked){
                cond.push(el.value);
            }; 
        }

        }
       

        if(cond.length){
            this.setState({"actualiza":""});
        }else{
        this.setState({"actualiza":"hide"});
        return;
        }
        // Si es nacional
        }

    }

    handleRegresar(){
        window.location.href="/solicitudes/drycip";
    }
    handleSave() {
      
        let cond = [];
        let chks = document.querySelectorAll(".conchk");
        for(let chk in chks){
          if(typeof chks[chk]==="object"){
            let el = chks[chk];
            
            if(el.checked){
                cond.push(el.value);
            };
          }
        }

        let data = JSON.parse(JSON.stringify(this.state));
        data.condiciones = cond;
        delete data.option_paises;
        delete data.options_conditions;
        delete data.options_identification;
        delete data.options_locations;
        delete data.regente;
        delete data.representante_legal;
        delete data.establecimiento;
        
        Swal.fire({
            title: "¿Seguro que desea guardar esta infomación?",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Regresar",
            reverseButtons: true,
            cancelButtonColor: "Red",
            confirmButtonColor: "#4CD964",
          }).then((result) => {
            if (result.isConfirmed) {
                Api.loading(1);

        Api
            .fetch("app/saveEstablecimientoSnap", {
                data: data
            }, "POST")
            .then((data) => {
                Swal
                .fire(
                    {title: "Anotación marginal enviada a evaluación", icon: "success", confirmButtonText: "Continuar"}
                ).then(function(){
                    window.location.href="/solicitudes/drycip";
                });
            });
        }});
    }

    handleAceptaCambios(e){
     
      let id = this.props.match.params["id"];
      let solid = this.props.match.params["solid"];
    
      let  estatus_tramite_id = 4;
      let notatext = "rechazada";
      if(e.target.innerText==="Aceptar"){
         estatus_tramite_id = 5;
         notatext  ="aceptada";
      }

      Swal.fire({
        title: "¿Seguro que desea "+e.target.innerText+" esta anotación marginal?",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
            Api.loading(1);
          return  Api
            .fetch("app/updateNotaMarginalEstablecimiento", {
                id:id,
                solid:solid,
                estatus_tramite_id:estatus_tramite_id,
                estatus:e.target.innerText
            }, "POST")
            .then((data) => {
                Swal
                .fire(
                    {title: "Anotación marginal "+notatext, icon: "success", confirmButtonText: "Continuar"}
                ).then(function(){
                    window.location.href="/solicitudes/drycip";
                });
            });
        }
    });

    }
    
    addRep(e) {
        let reps = [];
        let data = Api.serialize(document.getElementById("frmRep"));
        reps = this.state.representantes;

        let locs = Api.loadCatalogue("locations");
        let deps = locs.departamentos;
        let muns = locs.municipios;

        data["ubicacion"] = deps[deps.findIndex((x) => x.id.toString() === data.departamento_id)].name +
                ", " + muns[muns.findIndex((x) => x.id.toString() === data.municipio_id)].name;

        data.municipio = data["ubicacion"].split(",")[1];
        data.departamento = data["ubicacion"].split(",")[0];
        data.correo_electronico = data["email"];

        reps.push(data);

        this.setState({representantes: reps});

        let representante = {
            nombres: "",
            apellido_paterno: "",
            apellido_materno: "",
            direccion: "",
            tipo_documento_id: "",
            numero_identificacion: "",
            telefono: "",
            email: "",
            departamento_id: "",
            municipio_id: ""
        };
        this.setState({representante_legal: representante});
    }

    removeRep(e) {
        let representantes = [...this.state.representantes];
        representantes.splice(e.target.id, 1);
        this.setState({representantes: representantes});
    }

    handleDepartamentos(e) {
        let depa = this
            .state
            .options_locations
            .departamentos
            .find((d) => d.id.toString() === e.target.value);
        if(depa){
            this.setState({departamento_id: e.target.value, departamento_name: depa.name});
            this.handleLatLong(depa.name);
        }
    }

    handleMunicipios(e) {
        let muni = this
            .state
            .options_locations
            .municipios
            .find((d) => d.id.toString() === e.target.value);
        if(muni){
            this.setState({municipio_id: e.target.value, municipio_name: muni.name});
            if (this.state.departamento_id !== "") {
                this.handleLatLong(muni.name + '' + this.state.departamento_name);
            }
        }
    }

    handlePais(e) {
        let pais = this
            .state
            .option_paises
            .find((d) => d.descripcion === e.target.value);
        let lada = "+";
        if (pais.lada !== null) {
            lada = "+" + pais.lada;
        }

        this.setState({pais: e.target.value, lada: lada});

        this.handleLatLong(e.target.value);
    }

    handleDireccion(e) {
        this.setState({
            direccion: e
                .target
                .value
                .toUpperCase()
        });
        if (this.state.nacional === "1" && this.state.municipio_name !== "" && this.state.departamento_name !== "") {
            this.handleLatLong(
                e.target.value + " " + this.state.municipio_name + ' ' + this.state.departamento_name
            );
        } else if (this.state.nacional === "0" && this.state.pais !== "") {
            this.handleLatLong(e.target.value + " " + this.state.pais);
        }
    }

    handleActividades(e) {
        var act = [...this.state.actividades]; //copia del arreglo
        if (e.target.value !== "0" && !act.includes(e.target.value)) { //checamos que no se repitan elementos
            act.push(e.target.value);
        }
        this.setState({actividades: act}); //volvemos a reescribir la variable
    }

    handleCondiciones(e) {
        var cond = [...this.state.condiciones]; //copia del arreglo
        if (e.target.value !== "0" && !cond.includes(e.target.value)) {
            //checamos que no se repitan elementos
            cond.push(e.target.value);
        }
        this.setState({condiciones: cond}); //volvemos a reescribir la variable
    }

    handleRepresentante(e) {
        let rep = {
            ...this.state.representante_legal
        }; //hacemos una copia del objeto
        if (e.target.name === "nombres" || e.target.name === "apellido_paterno" || e.target.name === "apellido_materno" || e.target.name === "direccion") {
            rep[e.target.name] = e
                .target
                .value
                .toUpperCase();
        } else {
            rep[e.target.name] = e.target.value; //dependiendo del nombre del input cambia el valor
        }

        this.setState({representante_legal: rep});
    }

    /* REGENTES */

    handleRegente(e) {
        let rep = {
            ...this.state.regente
        };
        rep[e.target.name] = e
            .target
            .value
            .toUpperCase();
        this.setState({regente: rep});

       /*  if (e.target.name === "guid") {
            if (e.target.value.length === 4) {
                this.handleGuidRegente();
            }
        } */
    }

    removeReg(e) {
        let regentes = [...this.state.regentes];
        regentes.splice(e.target.id, 1);
        this.setState({regentes: regentes});
    }

    handleGuidRegente() {
        let reg = {
            nombres: this
                .getid("nombres")
                .value,
            apellido_paterno: this
                .getid("apellido_paterno")
                .value,
            apellido_materno: this
                .getid("apellido_materno")
                .value,
            guid: this
                .getid("guid")
                .value,
            tipo_establecimiento_id: this.state.tipo_establecimiento_id,
            // NORMA cupo: actividad de la solicitud/establecimiento (4,7,26 no suman cupo)
            actividades:
                this.state.actividades && this.state.actividades.length > 0
                    ? this.state.actividades
                    : this.state.actividad_id
                    ? [String(this.state.actividad_id)]
                    : [],
            actividad_id: this.state.actividad_id
                ? this.state.actividad_id
                : this.state.actividades && this.state.actividades.length > 0
                ? this.state.actividades[0]
                : null
        };

        if (reg.nombres === "" || reg.apellido_paterno === "" /* || reg.apellido_materno === "" */) {
            return;
        }
        this.setState({disabledR: true});
        //Api.loading(true);
        Api
            .fetch("app/getRegenteForEstablishments", reg, "POST")
            .then((data) => this.handleExisteRegente(data));
    }

    handleExisteRegente(data) {
        
        Api.loading(false);
        if (data.id) {
            if (data.tipo_regente_id === "2" && (this.state.tipo_establecimiento_id === "1" || this.state.tipo_establecimiento_id === "2")) {
                Swal.fire(
                    {title: "Error", icon: "warning", text: "Favor de ingresar un regente acuerdo al tipo de establecimiento."}
                ).then((result) => {
                    this.setState({disabledR: false});
                  });
            } else if (data.tipo_regente_id === "1" && (this.state.tipo_establecimiento_id === "4" || this.state.tipo_establecimiento_id === "3")) {
                Swal.fire(
                    {title: "Error", icon: "warning", text: "Favor de ingresar un regente acuerdo al tipo de establecimiento."}
                ).then((result) => {
                    this.setState({disabledR: false});
                  });
            } else {

                let reg = {
                    ...this.state.regente
                };
                reg["regente_id"] = data.id;
                this.setState({regente: reg});

                //this.setState({ existe_regente: true });

                let adr = document.querySelector("#addRegente");
                adr.classList = "btn btn-success";
                document
                    .querySelector("#addRegente i")
                    .classList = "fas fa-check";

                adr.addEventListener("click", (e) => {
                    if (adr.classList === "btn btn-light") {
                        return;
                    }
                    let reg = {
                        nombres: this
                            .getid("nombres")
                            .value,
                        apellido_paterno: this
                            .getid("apellido_paterno")
                            .value,
                        apellido_materno: this
                            .getid("apellido_materno")
                            .value,
                        guid: this
                            .getid("guid")
                            .value,
                        id: data.id
                    };

                    let regentes = this.state.regentes;

                    for (let re in regentes) {
                        if (regentes[re].nombres === reg.nombres) {
                            Swal.fire(
                                {title: "Atención", icon: "warning", text: "Ya cuenta con este regente en su lista."}
                            ).then((result) => {
                                this.setState({disabledR: false});
                                adr.classList = "btn btn-light";
                                document.querySelector("#addRegente i").classList = "fa fa-th";
                              });
                            return false;
                        }
                    }

                    regentes.push(reg);
                    this.setState({regentes: regentes});
                    adr.classList = "btn btn-light";
                    document
                        .querySelector("#addRegente i")
                        .classList = "fa fa-th";

                    let regente = {
                        regente_id: "",
                        nombres: "",
                        apellido_paterno: "",
                        apellido_materno: "",
                        guid: ""
                    };

                    this.setState({regente: regente,disabledR: false});

                }, {once: true});
            }
        } else {
            if(data.message){
                 Swal.fire({
                   title:
                     "Error al ingresar regente",
                   icon: "warning",
                   text: data.message,
                   confirmButtonText: "Continuar",
                 }).then((result) => {
                   this.setState({disabledR: false});
                 });
               }else{
                 Swal.fire({
                   title:
                     "Error al ingresar regente",
                   icon: "warning",
                   text: "Favor de ingresar un regente disponible con licencia vigente.",
                   confirmButtonText: "Continuar",
                 }).then((result) => {
                   this.setState({disabledR: false});
                 });
               }
            //this.setState({ existe_regente: false });
        }
    }

    /*ESTABLECIMIENTOS RELACIONADOS */

    handleEstablecimiento(e) {
        let est = {
            ...this.state.establecimiento
        };
        est[e.target.name] = e
            .target
            .value
            .toUpperCase();
        this.setState({establecimiento: est});

      /*   if (e.target.name === "guid") {
            if (e.target.value.length === 4) {
                this.handleGuidEstablecimiento();
            }
        } */
    }

    removeEst(e) {
        let establecimientos = [...this.state.establecimientos];
        establecimientos.splice(e.target.id, 1);
        this.setState({establecimientos: establecimientos});
    }

    handleGuidEstablecimiento() {
        let est = {
            razon_social: this
                .getid("razon_social_e")
                .value,
            guid: this
                .getid("guid_e")
                .value
        };

        if (est.razon_social === "") {
            return;
        }
        //Api.loading(true);
        Api
            .fetch("app/getValidEstablishment", est, "POST")
            .then((data) => this.handleExisteEstablecimiento(data));
    }

    handleExisteEstablecimiento(data) {
        
        //Api.loading(false);

        if (data.id) {
            if (((data.tipo_establecimiento_id === "4" || data.tipo_establecimiento_id === "3") && (this.state.tipo_establecimiento_id === "1" || this.state.tipo_establecimiento_id === "2")) || ((data.tipo_establecimiento_id === "1" || data.tipo_establecimiento_id === "2") && (this.state.tipo_establecimiento_id === "4" || this.state.tipo_establecimiento_id === "3"))) {
                Swal.fire({
                    title: "Error",
                    icon: "warning",
                    text: "Favor de ingresar un establecimiento de acuerdo al tipo de establecimiento act" +
                            "ual."
                });
            } else {

                let est = {
                    ...this.state.establecimiento
                };
                est["establecimiento_id"] = data.id;
                this.setState({establecimiento: est});

                //this.setState({ existe_regente: true });

                let adr = document.querySelector("#addEst");
                adr.classList = "btn btn-success";
                document
                    .querySelector("#addEst i")
                    .classList = "fas fa-check";

                adr.addEventListener("click", (e) => {
                    if (adr.classList === "btn btn-light") {
                        return;
                    }
                    let est = {
                        razon_social: this
                            .getid("razon_social_e")
                            .value,
                        guid: this
                            .getid("guid_e")
                            .value,
                        id: data.id
                    };

                    /*   this.getid("razon_social_e").value = "";
          this.getid("guid_e").value = "";
          this.getid("razon_social_e").focus(); */

                    let establecimientos = this.state.establecimientos;

                    for (let re in establecimientos) {
                        if (establecimientos[re].razon_social === est.razon_social) {
                            Swal.fire(
                                {title: "Atención", icon: "warning", text: "Ya cuenta con este establecimiento en su lista."}
                            );
                            adr.classList = "btn btn-light";
                            document
                                .querySelector("#addEst i")
                                .classList = "fa fa-th";
                            return false;
                        }
                    }

                    establecimientos.push(est);
                    this.setState({establecimientos: establecimientos});
                    adr.classList = "btn btn-light";
                    document
                        .querySelector("#addEst i")
                        .classList = "fa fa-th";

                    let establecimiento = {
                        establecimiento_id: "",
                        razon_social: "",
                        guid: ""
                    };

                    this.setState({establecimiento: establecimiento});
                }, {once: true});
            }
        } else {
            Swal.fire(
                {title: "Error al ingresar el establecimiento", icon: "warning", text: "Favor de ingresar un establecimiento con licencia vigente."}
            );
            //this.setState({ existe_regente: false });
        }
        
    }

    /* WIZARD */

    handleStep(e) {
        if(e.target.firstChild.classList){
            this.setState({activeStep: e.target.id});
        }
    }

    handleWarning() {
       
        Swal.fire({
            title: "Llenar la pestaña actual antes de continuar", icon: "warning", text: "Revise que la información este completa.", //message,
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        //this.setState({ procesando: true });

        if (this.state.nacional==="1") {
            if (
              this.state.area === "" ||
              this.state.direccion_bodegas === "" ||
              this.state.condiciones.length === 0
            ) {
              this.handleWarning();
              return;
            }
          }


            //getting request ready for fetch (without options), must to be a shallow copy.
            let postData = {
                ...this.state
            };
            
            // shallow copy is inherit of the main state
            delete postData.options_establishments;
            delete postData.options_conditions;
            delete postData.options_activities;
            delete postData.options_locations;
            delete postData.options_identification;
            delete postData.option_paises;
            Api.loading(true);
            Api
                .fetch("app/establishmentInscription", postData, "POST")
                .then((data) => this.handleRegister(data))
                .catch((error) => {
                    //return;
                    error
                        .json()
                        .then((message) => {
                            this.setState({procesando: false});
                            Swal.fire({
                                title: "Ocurrió un error al procesar la solicitud", icon: "error", text: "Revise la información e intente de nuevo su última acción", //message,
                            });
                        }); //catching errors to show notification
                });
        
    }

    getid(id) {
        return document.querySelector("#" + id);
    }

    handleRegister(e) {
        if (e.errors) { //|| e.exception
            let tplErrors = `Los siguientes campos son obligatorios: <u>`;

            for (let err in e.errors) {
                tplErrors += `<li>${err
                    .replace("_id", "")
                    .replace("_", " ")
                    .toUpperCase()}</li>`;
            }
            tplErrors += `</u>`;
            Swal.fire(
                {title: "Atención, verifique el formulario", icon: "error", html: tplErrors}
            );
            this.setState({procesando: false});
            return false;
        } else {

            Swal
                .fire(
                    {title: "Solicitud Generada", icon: "success", text: "Su solicitud ha sido recibida exitosamente.", confirmButtonText: "Continuar"}
                )
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location = "/establecimientos";
                    }
                });
        }

        this.setState({procesando: false});
    }

    handleLatLong(e) {

        Api
            .fetch("app/getLatLng?direccion=" + encodeURIComponent(e))
            .then((data) => {
                if (data) {
                    this.setState({latitud: data.lat, longitud: data.lng});
                }
            });

    }

    maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object
                .target
                .value
                .slice(0, object.target.maxLength)
        }
    }

    render() {

        return (
            <div >
                <div className="nav-wizards-container">
                    <nav className="nav nav-wizards-1 mb-2">
                        {
                            this
                                .state
                                .wizzard
                                .map((paso) => (
                                    <div
                                        onClick={this.handleStep}
                                        id={paso
                                            .titulo
                                            .toLowerCase()}
                                        key={paso.titulo}
                                        className="nav-item col">
                                        <div
                                            className={this.state.activeStep === paso
                                                .titulo
                                                .toLowerCase()
                                                    ? "active nav-link"
                                                    : "nav-link disabled"
}>
                                            <div className="nav-no">
                                                {
                                                    this
                                                        .state
                                                        .wizzard
                                                        .indexOf(paso) + 1
                                                }
                                            </div>
                                            <div className="nav-text">{paso.titulo}</div>
                                        </div>
                                    </div>
                                ))
                        }
                    </nav>
                </div>
                <div className="card">
                    <div className={"card-body "+this.state.locked}>
                        <div
                            className={this.state.activeStep === "establecimiento"
                                ? ""
                                : "hide"
}>
                            <fieldset>
                                <legend>Datos Generales</legend>
                                <div className="row">
                                <div className="col-12 hide" id="anotacion_marginal">
                                    <fieldset className="orange-stroke">
                                    <legend>
                                        Anotación marginal <b id="nota_marginal"></b>
                                    </legend>
                                    <div id="detalle_ame"></div>
                                    </fieldset>
                                </div>
                                
                                    
                                    <div className="form-group col-md-6">
                                        <label>Nombre del establecimiento</label>
                                        <span className="text-danger">
                                            *</span>
                                        <input type="text" name="razon_social" value={this.state.razon_social}
                                            //disabled={this.state.disabled}
                                            autoComplete="off" onChange={(e) => this.setState({razon_social: e.target.value})
} className="form-control m-b-5" placeholder="Nombre del establecimiento"
                                            //disabled={this.state.esBaja}
                                            required="required"/>
                                    </div>
                                    {/* NACIONAL */}
                                    <div
                                        className={this.state.nacional === "0"
                                            ? "hide"
                                            : "form-group col-md-6"}>
                                        <label>Teléfono Activo</label>
                                        <span className="text-danger">
                                            *</span>
                                        <input
                                            type="number"
                                            name="telefono"
                                            autoComplete="off"
                                            value={this.state.telefono}
                                            onChange={(e) => this.setState({telefono: e.target.value})
}
                                            className="form-control"
                                            maxLength="8"
                                            onInput={this.maxLengthCheck}
                                            placeholder="Ingrese teléfono activo"
                                            required="required"/>
                                    </div>
                                    {/* EXTRANJERO */}
                                    <div
                                        className={this.state.nacional === "0"
                                            ? "form-group col-md-6"
                                            : "hide"}>
                                        <label>Teléfono Activo</label>
                                        <span className="text-danger">
                                            *</span>
                                        <div className="row">
                                            <div className="col-md-2">
                                                <input
                                                    type="string"
                                                    name="lada"
                                                    autoComplete="off"
                                                    value={this.state.lada}
                                                    className="form-control "
                                                    placeholder="+"
                                                    readOnly={true}/>
                                            </div>
                                            <div className="col-md-10">
                                                <input
                                                    type="number"
                                                    name="telefono"
                                                    autoComplete="off"
                                                    value={this.state.telefono}
                                                    onChange={(e) => this.setState({telefono: e.target.value})
}
                                                    className="form-control"
                                                    maxLength="12"
                                                    onInput={this.maxLengthCheck}
                                                    placeholder="Ingrese teléfono activo"
                                                    required="required"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group col-md-6">
                                        <label>Correo Electrónico Activo</label>
                                        <span className="text-danger">
                                            *</span>
                                        <input
                                            type="email"
                                            name="email"
                                            autoComplete="off"
                                            value={this.state.correo_electronico}
                                            onChange={(e) => this.setState({correo_electronico: e.target.value})
}
                                            className="form-control"
                                            placeholder="Ingrese correo electrónico"
                                            required="required"/>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>Cédula RUC</label>
                                        <span className="text-danger">
                                            *</span>
                                        <input type="text" name="numero_de_identificacion" autoComplete="off" value={this.state.numero_de_identificacion} onChange={(e) => this.setState({numero_de_identificacion: e.target.value})
} className="form-control" placeholder="Ingrese cédula RUC"
                                            //disabled={this.state.esBaja}
                                        />
                                    </div>
                                </div>
                            </fieldset>
                            <br/>

                            <div className="row">
                                <fieldset
                                    className="col-md-6"
                                    style={{
                                        borderRight: "3px solid #222"
                                    }}>
                                    <legend>Ubicación</legend>
                                    <div
                                        id="departamento"
                                        className={this.state.nacional === "0"
                                            ? "hide"
                                            : "form-group col-md-12"}>
                                        <label>Departamento</label>
                                        <span className="text-danger">
                                            *</span>
                                        <select onChange={this.handleDepartamentos} name="departamento_id" className="form-control m-b-5" value={this.state.departamento_id}
                                            //disabled={this.state.esBaja}
                                        >
                                            <option className="dropdown-item">
                                                {" "}
                                                -- Seleccione --
                                            </option>
                                            {
                                                this
                                                    .state
                                                    .options_locations
                                                    .departamentos
                                                    .map((option, index) => (
                                                        <option key={index} className="dropdown-item"
                                                            //key={option.id}
                                                            value={option.id}>
                                                            {option.name}
                                                        </option>
                                                    ))
                                            }
                                        </select>
                                    </div>
                                    <div
                                        id="municipio"
                                        className={this.state.nacional === "0"
                                            ? "hide"
                                            : "form-group col-md-12"}>
                                        <label>Municipio</label>
                                        <span className="text-danger">
                                            *</span>
                                        <select onChange={this.handleMunicipios} name="municipio_id" className="form-control m-b-5" value={this.state.municipio_id}
                                            //disabled={this.state.esBaja}
                                        >
                                            <option className="dropdown-item">
                                                {" "}
                                                -- Seleccione --
                                            </option>
                                            {
                                                this
                                                    .state
                                                    .options_locations
                                                    .municipios
                                                    .filter((e) => e.estado_id === this.state.departamento_id)
                                                    .map((option) => (
                                                        <option className="dropdown-item"
                                                            //data-nombre=
                                                            
                                                            //key={option.id}
                                                            value={option.id}>
                                                            {option.name}
                                                        </option>
                                                    ))
                                            }
                                        </select>
                                    </div>

                                    <div
                                        id="pais"
                                        className={this.state.nacional === "0"
                                            ? "form-group col-md-12"
                                            : "hide"}>
                                        <label>País</label>
                                        <span className="text-danger">
                                            *</span>
                                        <select onChange={this.handlePais} name="pais_id" className="form-control m-b-5" value={this.state.pais}
                                            //disabled={this.state.esBaja}
                                        >
                                            <option className="dropdown-item">
                                                {" "}
                                                -- Seleccione --
                                            </option>
                                            {
                                                this
                                                    .state
                                                    .option_paises
                                                    .map((option) => (
                                                        <option className="dropdown-item" key={option.id} value={option.descripcion}>
                                                            {option.descripcion}
                                                        </option>
                                                    ))
                                            }
                                        </select>
                                    </div>

                                    <div className="form-group col-md-12">
                                        <label>Dirección</label>
                                        <span className="text-danger">
                                            *</span>
                                        <input
                                            type="text"
                                            name="direccion_establecimiento"
                                            autoComplete="off"
                                            value={this.state.direccion}
                                            onChange={this.handleDireccion}
                                            className="form-control"
                                            placeholder="Ingrese la dirección del establecimiento"
                                            required="required"/>
                                    </div>

                                    <div
                                        className="row"
                                        style={{
                                            paddingLeft: "0.8em",
                                            paddingRight: "0.8em"
                                        }}>
                                        <div className="form-group col-md-6">
                                            <label>Latitud</label>
                                            <span className="text-danger">
                                                *</span>
                                            <input
                                                type="number"
                                                autoComplete="off"
                                                value={this.state.latitud}
                                                onChange={(e) => this.setState({latitud: e.target.value})
}
                                                className="form-control "
                                                placeholder="Latitud"
                                                required="required"/>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Longitud</label>
                                            <span className="text-danger">
                                                *</span>
                                            <input
                                                type="number"
                                                autoComplete="off"
                                                value={this.state.longitud}
                                                onChange={(e) => this.setState({longitud: e.target.value})
}
                                                className="form-control "
                                                placeholder="Longitud"
                                                required="required"/>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="col-md-6">
                                    <legend>Geo Referencia</legend>
                                    <MapContainer
                                        style={{
                                            height: "100%",
                                            borderRadius: "6px",
                                            boxShadow: "0px 0px 10px 0px rgba(0,0,0,.5)"
                                        }}
                                        center={[this.state.latitud, this.state.longitud]}
                                        zoom={6}
                                        scrollWheelZoom={true}>
                                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
                                        <Marker position={[this.state.latitud, this.state.longitud]}
                                            //draggable="true"
                                        >
                                            <Popup>
                                                {/* A pretty CSS3 popup. <br /> Easily customizable. */}
                                            </Popup>
                                        </Marker>
                                    </MapContainer>
                                </fieldset>

                                {/*  <div className="col-md-12">
                  <div className="btn-group btn-group-justified pull-right">
                    <button className="btn btn-primary ">REGRESAR</button>
                    <button className="btn  btn-warning">REINICIAR</button>
                    <button className="btn  btn-success ">
                      SIGUIENTE PASO
                    </button>
                  </div>
                </div> */
                                }
                            </div>
                            <div className="text-right">
                                {" "}
                                Todos los campos con
                                <span className="text-danger">*</span>
                                son requeridos
                            </div>
                        </div>

                        <div
                            className={this.state.activeStep === "representante legal"
                                ? ""
                                : "hide"}>
                            {/* === REPRESENTANTE LEGAL === */}
                            <form id="frmRep">
                                <fieldset>
                                    <legend>Representante Legal</legend>
                                    <div className="row">
                                        <div className="form-group col-md-12">
                                            <label>Nombres</label>
                                            <span className="text-danger">
                                                *</span>
                                            <input type="text" name="nombres" value={this.state.representante_legal.nombres}
                                                //disabled={this.state.disabled}
                                                onChange={this.handleRepresentante} className="form-control" placeholder="Ingrese nombre(s)"
                                                //disabled={this.state.esBaja}
                                                required="required"/>
                                        </div>

                                        <div className="form-group col-md-6">
                                            <label>Apellido Paterno</label>
                                            <span className="text-danger">
                                                *</span>
                                            <input
                                                type="text"
                                                name="apellido_paterno"
                                                value={this.state.representante_legal.apellido_paterno}
                                                onChange={this.handleRepresentante}
                                                className="form-control"
                                                placeholder="Ingrese apellido paterno "
                                                required="required"/>
                                        </div>

                                        <div className="form-group col-md-6">
                                            <label>Apellido Materno</label>
                                            <input type="text" name="apellido_materno" value={this.state.representante_legal.apellido_materno} onChange={this.handleRepresentante} className="form-control" placeholder="Ingrese apellido materno "
                                                //required
                                            />
                                        </div>

                                        <div className="form-group col-md-12">
                                            <label>Dirección</label>
                                            <span className="text-danger">
                                                *</span>
                                            <input
                                                type="text"
                                                name="direccion"
                                                value={this.state.representante_legal.direccion}
                                                onChange={this.handleRepresentante}
                                                className="form-control"
                                                placeholder="Ingrese dirección "
                                                required="required"/>
                                        </div>

                                        <div className="form-group col-md-6">
                                            <label>Tipo de Identificación</label>
                                            <span className="text-danger">
                                                *</span>
                                            <select onChange={this.handleRepresentante} name="tipo_documento_id" className="form-control m-b-5" value={this.state.representante_legal.tipo_documento_id}
                                                //disabled={this.state.esBaja}
                                            >
                                                <option className="dropdown-item">Seleccione...</option>
                                                {
                                                    this
                                                        .state
                                                        .options_identification
                                                        .tipo_identificacion
                                                        .map((option) => (
                                                            <option className="dropdown-item" key={option.id} value={option.id}>
                                                                {option.descripcion}
                                                            </option>
                                                        ))
                                                }
                                            </select>
                                        </div>

                                        <div className="form-group col-md-6">
                                            <label>Número de Identificación</label>
                                            <span className="text-danger">
                                                *</span>
                                            <input
                                                type="text"
                                                name="numero_identificacion"
                                                value={this.state.representante_legal.numero_identificacion
}
                                                onChange={this.handleRepresentante}
                                                className="form-control"
                                                placeholder="Ingrese número de identificación "
                                                required="required"/>

                                        </div>

                                        <div className="form-group col-md-6">
                                            <label>Teléfono Activo</label>
                                            <span className="text-danger">
                                                *</span>
                                            <input type="number" name="telefono"
                                                //pattern="[0-9]{4}[0-9]{4}"
                                                maxLength="8" onInput={this.maxLengthCheck} value={this.state.representante_legal.telefono} onChange={this.handleRepresentante} className="form-control" placeholder="Ingrese teléfono activo " required="required"/>
                                        </div>

                                        <div className="form-group col-md-6">
                                            <label>Correo Electrónico Activo</label>
                                            <span className="text-danger">
                                                *</span>
                                            <input
                                                type="email"
                                                name="email"
                                                value={this.state.representante_legal.email}
                                                onChange={this.handleRepresentante}
                                                className="form-control"
                                                placeholder="Ingrese correo electrónico "
                                                required="required"/>

                                        </div>

                                        <div className="form-group col-md-6">
                                            <label>Departamento</label>
                                            <span className="text-danger">
                                                *</span>
                                            <select onChange={this.handleRepresentante} name="departamento_id" className="form-control m-b-5" value={this.state.representante_legal.departamento_id}
                                                //disabled={this.state.esBaja}
                                            >
                                                <option className="dropdown-item">
                                                    {" "}
                                                    Seleccione...
                                                </option>
                                                {
                                                    this
                                                        .state
                                                        .options_locations
                                                        .departamentos
                                                        .map((option, index) => (
                                                            <option className="dropdown-item" key={index} value={option.id}>
                                                                {option.name}
                                                            </option>
                                                        ))
                                                }
                                            </select>
                                        </div>

                                        <div className="form-group col-md-6">
                                            <label>Municipio</label>
                                            <span className="text-danger">
                                                *</span>
                                            <select onChange={this.handleRepresentante} name="municipio_id" className="form-control m-b-5" value={this.state.representante_legal.municipio_id}
                                                //disabled={this.state.esBaja}
                                            >
                                                <option className="dropdown-item">Seleccione...</option>
                                                {
                                                    this
                                                        .state
                                                        .options_locations
                                                        .municipios
                                                        .filter((e) => e.estado_id === this.state.representante_legal.departamento_id)
                                                        .map((option) => (
                                                            <option className="dropdown-item"
                                                                //key={option.id}
                                                                value={option.id}>
                                                                {option.name}
                                                            </option>
                                                        ))
                                                }
                                            </select>
                                        </div>

                                        <div
                                            className="form-group col-md-12"
                                            style={{
                                                textAlign: "right"
                                            }}>
                                            <div onClick={this.addRep} className="btn btn-primary">
                                                Agregar representante
                                            </div>
                                        </div>
                                        <div className="form-group col-md-12" id="listaRepresentantes">
                                            <table className="table table-striped m-b-0 table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Nombre</th>
                                                        <th>Apellido paterno</th>
                                                        <th>Apellido materno</th>
                                                        <th>Correo electrónico</th>
                                                        <th>Ubicación</th>
                                                        <th>Acción</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this
                                                            .state
                                                            .representantes
                                                            .map((rep, index) => (
                                                                <tr key={index} id={"t" + index}>
                                                                    <td>{rep.nombres}</td>
                                                                    <td>{rep.apellido_paterno}</td>
                                                                    <td>{rep.apellido_materno}</td>
                                                                    <td>{rep.correo_electronico}</td>
                                                                    <td>{rep.departamento}, {rep.municipio}</td>
                                                                    <td>
                                                                        <button id={index} onClick={this.removeRep} className="btn btn-warning">
                                                                            <i id={index} onClick={this.removeRep} className="fas fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                            <div className="text-right">
                                {" "}
                                Todos los campos con * son requeridos
                            </div>
                        </div>

                        <div
                            className={this.state.activeStep === "regente"
                                ? ""
                                : "hide"}>
                            <fieldset>
                                <legend>Regente</legend>
                                <div className="row">
                                    <div className="form-group col-md-12">
                                        <label>Nombres</label>

                                        <input
                                            type="text"
                                            name="nombres"
                                            id="nombres"
                                            onChange={this.handleRegente}
                                            value={this.state.regente.nombres}
                                            className="form-control"
                                            placeholder="Ingrese nombre(s)"
                                            disabled={this.state.disabledR}
                                            required="required"/>

                                    </div>

                                    <div className="form-group col-md-6">
                                        <label>Apellido Paterno</label>

                                        <input
                                            type="text"
                                            name="apellido_paterno"
                                            id="apellido_paterno"
                                            value={this.state.regente.apellido_paterno}
                                            onChange={this.handleRegente}
                                            className="form-control"
                                            placeholder="Ingrese apellido paterno "
                                            disabled={this.state.disabledR}
                                            required="required"/>

                                    </div>

                                    <div className="form-group col-md-6">
                                        <label>Apellido Materno</label>

                                        <input
                                            type="text"
                                            name="apellido_materno"
                                            id="apellido_materno"
                                            value={this.state.regente.apellido_materno}
                                            onChange={this.handleRegente}
                                            className="form-control"
                                            placeholder="Ingrese apellido materno "
                                            disabled={this.state.disabledR}
                                            required="required"/>
                                    </div>

                                    <div className="form-group col-md-3">
                                        <label>GUID</label>

                                        <input
                                            type="text"
                                            name="guid"
                                            id="guid"
                                            onChange={this.handleRegente}
                                            value={this.state.regente.guid}
                                            className="form-control"
                                            maxLength="4"
                                            placeholder="Ingrese GUID "
                                            disabled={this.state.disabledR}
                                            required="required"/>
                                    </div>

                                    <div className="col-md-3">
                                        <br/>
                                        <div id="addRegente" onClick={this.handleGuidRegente} className=" btn btn-light">
                                            <i className="fa fa-th"></i>
                                        </div>
                                    </div>
                                </div>
                                <br/>
                                <div id="listaRegentes">
                                    <table className="table table-striped m-b-0 table-hover">
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Apellido paterno</th>
                                                <th>Apellido materno</th>
                                                <th>GUID</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this
                                                    .state
                                                    .regentes
                                                    .map((reg, index) => (
                                                        <tr key={index} id={"t" + index}>
                                                            <td>{reg.nombres}</td>
                                                            <td>{reg.apellido_paterno}</td>
                                                            <td>{reg.apellido_materno}</td>
                                                            <td>{reg.guid}</td>
                                                            <td>
                                                                <button id={index} onClick={this.removeReg} className="btn btn-warning">
                                                                    <i id={index} onClick={this.removeReg} className="fas fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </fieldset>

                            <div className="text-right">
                                {" "}
                                Todos los campos con * son requeridos
                            </div>
                        </div>

                        <div
                            className={this.state.activeStep === "características"
                                ? ""
                                : "hide"
}>
                            <div className="row">
                                <div className="form-group col-md-12">
                                    <fieldset>
                                        <legend>Características del Establecimiento</legend>
                                        <div className="row">
                                            <div className="form-group col-md-12">
                                                <label>Área total(m²)</label>
                                                <span className="text-danger">
                                                {this.state.nacional === "0" ? "" : "*"}</span>
                                                <input
                                                    type="number"
                                                    name="area"
                                                    onInput={this.maxLengthCheck}
                                                    value={this.state.area}
                                                    onChange={(e) => this.setState({area: e.target.value})
}
                                                    className="form-control"
                                                    placeholder="Ingrese el área total "
                                                    maxLength="6"
                                                    required="required"/>
                                            </div>
                                            <div className="form-group col-md-12">
                                                <label>Dirección de bodegas y almacenamiento</label>
                                                <span className="text-danger">
                                                {this.state.nacional === "0" ? "" : "*"}</span>
                                                <textarea
                                                    type="text"
                                                    name="direccion_bodegas"
                                                    value={this.state.direccion_bodegas}
                                                    onChange={(e) => this.setState({
                                                        direccion_bodegas: e
                                                            .target
                                                            .value
                                                            .toUpperCase()
                                                    })
}
                                                    className="form-control"
                                                    placeholder="Ingrese la dirección de bodegas y almacenamiento"
                                                    required="required"/>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>

                            <div className="row">
                                <div className="form-group col-md-12">
                                    <fieldset>
                                        <legend>
                                            Condiciones, Equipos y medios disponibles (donde se almacenan y distribuyen los
                                            productos)
                                        </legend>
                                        <span className="text-danger">
                                        {this.state.nacional === "0" ? "" : "*"}</span>

                                        <table className="table table-striped m-b-0 table-hover">
                                            <tbody>
                                                {
                                                    this
                                                        .state
                                                        .options_conditions
                                                        .condiciones
                                                        .map((option, index) => (
                                                            <tr key={index}>
                                                                <td>{option.descripcion}</td>
                                                                <td>
                                                                    <input className="conchk" id={"con-" + option.id} type="checkbox"
                                                                        //checked={isSelected}
                                                                        value={option.id} onClick={this.handler} onChange={this.handleCondiciones} style={{
                                                                            marginRight: "5px"
                                                                        }}/>
                                                                </td>
                                                            </tr>
                                                        ))
                                                }
                                            </tbody>
                                        </table>
                                    </fieldset>
                                    <div className="text-right">
                                        {" "}
                                        Todos los campos con
                                        <span className="text-danger">*</span>
                                        son requeridos
                                    </div>
                                </div>
                            </div>

                            <div
                                className={this.state.procesando
                                    ? "progress rounded-corner m-b-15"
                                    : "hide"
}>
                                <div
                                    className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
                                    style={{
                                        width: "100%",
                                        height: "20px"
                                    }}>
                                    <h4>Cargando, espere...</h4>
                                </div>
                            </div>

                            <div
                                className={this.state.procesando
                                    ? "hide"
                                    : "pull-right"}></div>
                            <br></br>
                        </div>

                        <div
                            className={this.state.activeStep === "establecimientos relacionados"
                                ? ""
                                : "hide"}>
                            <fieldset>
                                <legend>Establecimientos relacionados</legend>
                                <div className="row">
                                    <div className="form-group col-md-6">
                                        <label>Razón social</label>
                                        <input
                                            type="text"
                                            name="razon_social"
                                            id="razon_social_e"
                                            onChange={this.handleEstablecimiento}
                                            value={this.state.establecimiento.razon_social}
                                            className="form-control"
                                            placeholder="Ingrese razón social del establecimiento"
                                            required="required"/>
                                    </div>

                                    <div className="form-group col-md-5">
                                        <label>GUID</label>

                                        <input
                                            type="text"
                                            name="guid"
                                            id="guid_e"
                                            onChange={this.handleEstablecimiento}
                                            value={this.state.establecimiento.guid}
                                            className="form-control"
                                            maxLength="4"
                                            placeholder="Ingrese GUID "
                                            required="required"/>
                                    </div>

                                    <div className="col-md-1">
                                        <br/>
                                        <div id="addEst" onClick={this.handleGuidEstablecimiento} className=" btn btn-light">
                                            <i className="fa fa-th"></i>
                                        </div>
                                    </div>
                                </div>
                                <br/>
                                <div id="listaEstablecimientos">
                                    <table className="table table-striped m-b-0 table-hover">
                                        <thead>
                                            <tr>
                                                <th>Razón social</th>
                                                <th>GUID</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this
                                                    .state
                                                    .establecimientos
                                                    .map((est, index) => (
                                                        <tr key={index} id={"t" + index}>
                                                            <td>{est.razon_social}</td>
                                                            <td>{est.guid}</td>
                                                            <td>
                                                                <button id={index} onClick={this.removeEst} className="btn btn-warning">
                                                                    <i id={index} onClick={this.removeEst} className="fas fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </fieldset>
                            <div className="text-right">
                                {" "}
                                Todos los campos con * son requeridos
                            </div>
                        </div>
                       
                    </div>

                    <hr></hr>
                    <div className="row">
                            <div
                                className={this.state.estatus_tramite_id === "13"
                                    ? "col-md-12"
                                    : "hide"}>
                                  <div className={this.state.actualiza+" col-md-12"}>
                                  <div className="btn-group pull-left col-md-4">
                                        <button onClick={this.handleRegresar}  className="btn btn-danger">Regresar</button>
                                    </div>

                                      <div className="btn-group pull-right col-md-4">
                                  <button
                                      type="button"
                                      onClick={this.handleSave}
                                      className="btn btn-success m-r-5">
                                      Actualizar información
                                  </button>
                                  </div>
                                </div>
                            </div>
                            <div
                                className={this.state.estatus_tramite_id === 14
                                    ? "col-md-12"
                                    : "hide"}>

                                <div className="col-md-12">
                                    <div className="btn-group pull-left col-md-4">
                                        <button onClick={this.handleAceptaCambios}  className="btn btn-danger">Rechazar</button>
                                    </div>
                                    <div className="btn-group pull-right col-md-4">
                      
                                        <button   onClick={this.handleAceptaCambios} className="btn btn-success">Aceptar</button>
                                    </div>
                                </div>

                            </div>
                        </div><br />
                </div>
            </div>
        );
    }
}

export default(props) => {
    const auth = useAuth();
    const history = useHistory();
    const match = useRouteMatch();
    return (
        <EstablishmentEdition auth={auth} history={history} match={match} {...props}/>
    );
};
